import axios from 'axios';
import jsonpAdapter from 'axios-jsonp';

import { processResponse, processError } from './response';

/**
 * Make a jsonp request. This is necessary for advertisement.
 */
export default function jsonp(options) {
  return axios({
    ...options,
    adapter: jsonpAdapter,
    callbackParamName: 'jsonp',
  })
    .then(processResponse)
    .catch(processError);
}
